import { Injectable } from '@angular/core';

import { TrialInsightsChartModel } from '../../models/trial-insights-chart.model';
import { TrialInsightsLegendOptions } from '../../models/trial-insights-legend.model';

@Injectable({
  providedIn: 'root',
})
export class TrialInsightsClinicalSiteCostChartService implements TrialInsightsChartModel {
  createLegend = (sitesActivated?: number, sitesClosed?: number): TrialInsightsLegendOptions => {
    return {
      centered: false,
      color: '',
      compact: false,
      data: [
        {
          displayDivider: false,
          displayIcon: true,
          iconColor: '#128ee7',
          title: 'Active (Forecast)',
          value: (sitesActivated || 0) + '',
          valueColor: '#128ee7',
        },
        {
          displayDivider: false,
          displayIcon: true,
          iconColor: '#4e6d79',
          title: 'Closed (Forecast)',
          value: (sitesClosed || 0) + '',
          valueColor: '#4e6d79',
        },
      ],
      divider: false,
    };
  };
}
